module.exports = __webpack_public_path__ + "img/labmemtest_title_sc.3a9db8a0.png";